<template>
  <div class="h-auto">
    <div v-if="institutionlist">
      <div class="row">
        <div class="col">
          <div class="alert alert-primary group-title pt-2 pb-2">
            <div class="row">
              <div class="col my-auto">
                <icon :icon="['fad', 'history']"/>
                {{_[abstract.setting_submission_id].institute.previous_title}}
              </div>
              <div class="col">
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <icon :icon="['fad', 'search']"/>
                    </div>
                  </div>
                  <input type="text" class="form-control"
                         :placeholder="_[abstract.setting_submission_id].institute.previous_search_placeholder"
                         v-model="search">
                  <div class="input-group-append">
                    <div class="input-group-text pointer-click" v-on:click="search = ''">
                      <icon :icon="['fad', 'times']"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="list-group">
            <button type="button" class="list-group-item list-group-item-action" v-for="(institute) in institutionlist"
                    v-bind:key="institute.id" v-on:click="$emit('cloneInstitute', institute)">
              <div>
                <span>{{institute.name}}</span>
                <span v-if="institute.department" class="smaller">,&nbsp;{{institute.department}}</span>
                <span v-if="institute.city" class="smaller">,&nbsp;{{institute.city}}</span>
                <span v-if="institute.country_code"
                      class="smaller">,&nbsp;{{_[0].country[institute.country_code]}}</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: "PreviousInstituteList",
    computed: {
      ...mapState([
        'used_institutes',
        'wording',
        'processing',
        'settings',
        'abstract',
        'user'
      ]),
      institutionlist: function () {
        if (this.search.length > 0) {
          return this.used_institutes.filter(institute => institute.name.toUpperCase().indexOf(this.search.toUpperCase()) > -1)
        }
        return this.used_institutes;
      }
    },
    data() {
      return {
        search: ''
      };
    },
    methods: {
      ...mapActions(['GET_USED_INSTITUTES']),
    },
    created() {
      this.GET_USED_INSTITUTES();
    }
  }
</script>
<style scoped lang="css">
  .list-group {
    max-height: 300px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
</style>
<style scoped>

</style>
